export const reduxKey = 'flags';
export const actionKey = '@@flags';
